var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connect"},[_c('div',{staticClass:"cont"},[_c('p',[_vm._v(_vm._s(_vm.$t('lang.foot_Phone')))]),_c('p',[_vm._v(_vm._s(_vm.$t('lang.foot_Mailbox')))]),_c('p',[_vm._v(_vm._s(_vm.$t('lang.foot_Address')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }